
/* ==========================================================================
   LINKS — static filenames to theme routes

   The front end links to `accessories.html`, `machine.html?m=smith` and so
   on, because that is what the static build is. On Shopify those are pages
   and products with entirely different URLs, and every one of them 404s.

   The layout publishes the real routes as window.IFZ_URLS; this maps the
   static names onto them. With IFZ_URLS unset — the static build — every
   link is returned untouched, so one codebase serves both.

   Rewriting happens in two places: every anchor on the page at load, and
   again on click, because a lot of these links are built by JS long after
   load (the deck, the menu, the package rack).
   ========================================================================== */
window.IFZU = function (href) {
  var U = window.IFZ_URLS;
  if (!href || !U) return href;

  var m = String(href).match(/^([a-z-]+\.html)(\?[^#]*)?(#.*)?$/i);
  if (!m) return href;

  var file = m[1].toLowerCase(), query = m[2] || '', hash = m[3] || '';

  if (file === 'machine.html') {
    var mk = (query.match(/[?&]m=([a-z0-9-]+)/i) || [])[1];
    var handle = U.products && U.products[mk];
    return handle ? (U.productBase + handle + hash) : (U.home + hash);
  }
  if (file === 'tools.html')       return U.tools + hash;
  if (file === 'accessories.html') return U.accessories + hash;
  if (file === 'bundle.html')      return U.package + query + hash;
  if (file === 'cart-revamp.html') return U.cart + hash;
  if (file === 'index.html')       return U.home + hash;
  return href;
};

(function () {
  function sweep(root) {
    if (!window.IFZ_URLS) return;
    var as = (root || document).querySelectorAll('a[href]');
    for (var i = 0; i < as.length; i++) {
      var h = as[i].getAttribute('href');
      var n = window.IFZU(h);
      if (n !== h) as[i].setAttribute('href', n);
    }
  }
  window.IFZUSweep = sweep;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sweep(); });
  } else { sweep(); }

  /* Anything built after load — the menu, the deck, the package rack. */
  document.addEventListener('click', function (e) {
    if (!window.IFZ_URLS || !e.target.closest) return;
    var a = e.target.closest('a[href]');
    if (!a) return;
    var h = a.getAttribute('href');
    var n = window.IFZU(h);
    if (n !== h) a.setAttribute('href', n);
  }, true);
})();

/* ==========================================================================
   ASSET PATHS — static site and Shopify theme from one codebase

   On the static site an image lives at `assets/spin-cable-1.jpg`. In a
   Shopify theme the same file is served from the CDN under a hashed URL,
   and there is no `assets/` folder to be relative to.

   So every path goes through here. The layout sets IFZ_ASSET_BASE:

     window.IFZ_ASSET_BASE = "{{ 'ifz-icon.svg' | asset_url | split: 'ifz-icon.svg' | first }}";

   With it unset — which is the static site — this returns the path
   untouched, so the two behave identically and there is no second codebase
   to keep in step.
   ========================================================================== */
window.IFZA = function (path) {
  if (!path) return path;

  /* The 3D models are 12-15 MB each and 41 MB together, which pushes a
     theme past Shopify's 50 MB zip limit on its own. So they live in
     Shopify Files instead of the theme, and IFZ_MODEL_BASE points at them.
     Everything else comes from the theme's own assets. */
  if (window.IFZ_MODEL_BASE && /\.glb(\?|$)/i.test(path)) {
    return String(path).replace(/^assets\//, window.IFZ_MODEL_BASE);
  }

  var base = window.IFZ_ASSET_BASE;
  if (!base) return path;
  return String(path).replace(/^assets\//, base);
};

/* ==========================================================================
   IRON FIT — shared cart store
   localStorage-backed so the cart survives page moves and reloads.
   Items: { type: 'machine'|'package'|'accessory'|'tool', name, price,
            img, qty, extras: [{ name, price }], includes: [strings] }
   Any element with [data-cart-count] becomes a live badge.

   `img` and `qty` are newer than the rest. Both are optional everywhere —
   a cart written before they existed still reads, and a caller that omits
   them still works (qty falls back to 1, the thumbnail slot to a
   placeholder). That matters: this is localStorage, so a returning
   customer's cart predates today's code.
   ========================================================================== */
window.IFZCart = (function () {
  'use strict';

  var KEY = 'ifz-cart-v1';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }

  function write(items) {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {}
    badge();
  }

  function qtyOf(it) { return Math.max(1, parseInt(it && it.qty, 10) || 1); }

  /* Two lines are the same line only if the thing AND its extras match —
     a Smith machine with 40 kg of plates is not the same order line as a
     bare one, and merging them would silently change what was bought. */
  function sig(it) {
    return [it.type, it.name, it.price].concat(
      (it.extras || []).map(function (e) { return e.name + ':' + e.price; }).sort()
    ).join('|');
  }

  function add(item) {
    var it = read();
    var s = sig(item);
    var merged = false;
    for (var i = 0; i < it.length; i++) {
      if (sig(it[i]) === s) { it[i].qty = qtyOf(it[i]) + qtyOf(item); merged = true; break; }
    }
    if (!merged) { item.qty = qtyOf(item); it.push(item); }
    write(it);
    /* the pixel is only present on pages that load ifz-pixel.js */
    if (window.IFZPixel) window.IFZPixel.addToCart(item);
  }

  function removeAt(i) { var it = read(); it.splice(i, 1); write(it); }

  /* Down to zero removes the line — the same thing the Remove button does,
     reached the way people expect from every other cart. */
  function setQty(i, q) {
    var it = read();
    if (!it[i]) return;
    q = Math.max(0, Math.min(99, parseInt(q, 10) || 0));
    if (q === 0) it.splice(i, 1); else it[i].qty = q;
    write(it);
  }

  function clear() { write([]); }

  function count() {
    return read().reduce(function (s, it) { return s + qtyOf(it); }, 0);
  }

  function itemTotal(it) {
    var t = it.price;
    (it.extras || []).forEach(function (e) { t += e.price; });
    return t * qtyOf(it);
  }

  /* ----------------------------------------------------------------------
     DELIVERY

     ONE TRIP, SO ONE CHARGE — THE HIGHEST THAT APPLIES.

     Everything in an order arrives on the same van, so nobody pays twice for
     the same journey. But the journeys are not equal: a socket set posts for
     $4, a bench needs a vehicle and two people. So the basket is charged the
     dearest rate in it, once — a bench and three socket sets is $20, not $32
     and not $24.

     That is a whole-basket rule, not a per-line one, which is why it lives
     here rather than on the products. Add a bench to a basket of kits and
     the charge goes from $4 to $20; take it out again and it drops back.

     Tools and accessories are flat — $4 and $20, the same in Beirut as in
     Akkar, because a socket set goes in a van that was already going. A
     machine does not: it is priced by region below, $50 to $100, and it is
     always the dearest thing in a basket. So any order with a machine in it
     pays the machine's rate and everything else rides along on it.
     ---------------------------------------------------------------------- */
  var DELIVERY = { tool: 4, accessory: 20 };

  /* MACHINES ARE PRICED BY REGION, because the cost of putting 200 kg up a
     staircase in Akkar is not the cost of doing it in Beirut. The keys are
     the option values of EasySell's own Region field, so the rate a customer
     is charged and the rate shown here cannot drift apart.

     WATCH THE TWO ODD ONES: Beirut is LB_BA and Beqaa is LB_BI, which is the
     opposite way round to what anybody would guess. They are read off the
     live form, not from the ISO list — do not "correct" them.

     Distance as driven, not as the crow flies: Beqaa matches South rather
     than beating it because Zahlé is only 55 km but over the Dahr el-Baidar
     pass, and Nabatieh costs more than the nearer coast because it climbs. */
  var MACHINE_BY_REGION = {
    LB_BA: 50,    /* Beirut           — base */
    LB_JL: 60,    /* Mount Lebanon    — the ring around it */
    LB_JA: 75,    /* South            — Sidon 45 km, Tyre 80, coastal */
    LB_BI: 75,    /* Beqaa            — 55 km but over the pass */
    LB_AS: 80,    /* North            — Tripoli 85 km, motorway */
    LB_NA: 85,    /* Nabatieh         — 70 km, inland and climbing */
    LB_BH: 95,    /* Baalbek-Hermel   — Baalbek 85 km, Hermel 140 */
    LB_AK: 100    /* Akkar            — the far corner */
  };
  var MACHINE_MIN = 50;

  /* THE REGION IS CHOSEN BEFORE CHECKOUT, NOT DURING IT.

     EasySell reads the Shopify cart once, when its form opens, and never
     looks again — tested: a line added while the form was up did not appear.
     So a delivery charge that depends on the region has to be in the cart
     BEFORE that moment, which means the region has to be asked for on our own
     cart page rather than inside the order form.

     Kept in its own localStorage key so it survives the reload the cart page
     does, and so the bridge can read the same answer the page displayed. */
  var RKEY = 'ifz-region';

  function region() {
    try { return localStorage.getItem(RKEY) || ''; } catch (e) { return ''; }
  }
  function setRegion(code) {
    try { localStorage.setItem(RKEY, code || ''); } catch (e) {}
  }

  function hasMachine() {
    return read().some(function (x) {
      return x && (x.type === 'machine' || x.type === 'package');
    });
  }

  /* `region` is one of those codes, or nothing. Nothing is the normal case on
     the cart page — the customer has not opened the order form yet, so the
     honest answer there is "from $50", not a number we would have to correct
     in front of them. */
  function delivery(reg) {
    if (reg === undefined) reg = region();
    var items = read();
    if (!items.length) return 0;

    var flat = items.reduce(function (top, x) {
      var rate = DELIVERY[x && x.type];
      return (typeof rate === 'number' && rate > top) ? rate : top;
    }, 0);

    if (!hasMachine()) return flat;
    var m = MACHINE_BY_REGION[reg] || MACHINE_MIN;
    return m > flat ? m : flat;
  }

  /* True when the figure above is a floor rather than the price. */
  function deliveryIsFrom(reg) {
    if (reg === undefined) reg = region();
    return hasMachine() && !MACHINE_BY_REGION[reg];
  }

  function total(reg) {
    return read().reduce(function (s, it) { return s + itemTotal(it); }, 0) + delivery(reg);
  }

  function money(n) { return '$' + n.toLocaleString('en-US'); }

  function badge() {
    var n = count();
    var els = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = n;
      if (n === 0) { els[i].setAttribute('hidden', ''); }
      else { els[i].removeAttribute('hidden'); }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', badge);
  } else {
    badge();
  }

  return { read: read, write: write, add: add, removeAt: removeAt, setQty: setQty,
           qtyOf: qtyOf, clear: clear, count: count, total: total,
           itemTotal: itemTotal, money: money, badge: badge,
           delivery: delivery, deliveryIsFrom: deliveryIsFrom,
           hasMachine: hasMachine, region: region, setRegion: setRegion,
           DELIVERY: DELIVERY,
           MACHINE_BY_REGION: MACHINE_BY_REGION, MACHINE_MIN: MACHINE_MIN };
})();

/* ==========================================================================
   Shared picture builder — WebP with a JPEG underneath.

   Every photo on the site now ships in both formats; WebP is about half the
   weight at the same quality. A <picture> lets the browser choose, so a
   phone too old for WebP (an iPhone on iOS 13, say) still gets the JPEG
   rather than an empty box.

   IFZPic('assets/x.jpg', alt) → <picture><source …webp><img src=…jpg></picture>

   A browser that takes the <source> does NOT fall back to the <img> on its
   own if that WebP is missing — it just shows nothing. So the one error the
   caller can actually make (a file with no .webp beside it) is caught here:
   drop the source and let the original load.
   ========================================================================== */
window.IFZPic = function (src, alt, cls) {
  src = window.IFZA(src);
  var pic = document.createElement('picture');

  var source = document.createElement('source');
  source.type = 'image/webp';
  source.srcset = src.replace(/\.(jpe?g|png)$/i, '.webp');
  pic.appendChild(source);

  var img = document.createElement('img');
  img.alt = alt || '';
  if (cls) img.className = cls;

  img.addEventListener('error', function once() {
    img.removeEventListener('error', once);
    if (!source.parentNode) return;
    pic.removeChild(source);
    img.src = src;                 /* re-run the pick, now JPEG-only */
  });

  img.src = src;
  pic.appendChild(img);

  return pic;
};

/* ==========================================================================
   Shared extra-plates picker — the old builder's UI: pairs of 5 / 10 / 20 kg
   plates, capped at 80 kg extra. A pair adds 2 × its size.
   IFZPlates(container, onChange) → { kg(), rows() }
   Pricing is the caller's job (package rate vs standalone rate differ).
   ========================================================================== */
window.IFZPlates = function (container, onChange) {
  'use strict';

  var MAX_KG = 80;
  var SIZES = [5, 10, 20];
  var pairs = { 5: 0, 10: 0, 20: 0 };

  function kg() {
    return 2 * (5 * pairs[5] + 10 * pairs[10] + 20 * pairs[20]);
  }

  var reads = {};

  function refresh() {
    SIZES.forEach(function (s) {
      reads[s].count.textContent = pairs[s];
      reads[s].added.textContent = '(+' + (2 * s * pairs[s]) + ' KG)';
    });
    onChange(kg());
  }

  SIZES.forEach(function (s) {
    var row = document.createElement('div');
    row.className = 'plr';

    var badge = document.createElement('span');
    badge.className = 'plr__badge';
    badge.innerHTML = s + '<small>KG</small>';

    var name = document.createElement('span');
    name.className = 'plr__name';
    name.textContent = s + ' KG Plates';

    var qty = document.createElement('div');
    qty.className = 'plr__qty';
    var minus = document.createElement('button');
    minus.type = 'button'; minus.textContent = '−';
    minus.setAttribute('aria-label', 'Fewer pairs of ' + s + ' kg plates');
    var n = document.createElement('span'); n.textContent = '0';
    var plus = document.createElement('button');
    plus.type = 'button'; plus.textContent = '+';
    plus.setAttribute('aria-label', 'More pairs of ' + s + ' kg plates');
    qty.appendChild(minus); qty.appendChild(n); qty.appendChild(plus);

    var side = document.createElement('span');
    side.className = 'plr__side';
    var added = document.createElement('b');
    added.textContent = '(+0 KG)';
    side.appendChild(document.createTextNode('Pairs '));
    side.appendChild(added);

    reads[s] = { count: n, added: added };

    minus.addEventListener('click', function (e) {
      e.stopPropagation();
      if (pairs[s] > 0) { pairs[s]--; refresh(); }
    });
    plus.addEventListener('click', function (e) {
      e.stopPropagation();
      if (kg() + 2 * s <= MAX_KG) { pairs[s]++; refresh(); }
    });

    row.appendChild(badge); row.appendChild(name); row.appendChild(qty); row.appendChild(side);
    container.appendChild(row);
  });

  return { kg: kg };
};

/* ==========================================================================
   Shared rubber-flooring picker.
   IFZFloor(container, onChange) → { m2() }

   Sold by the square metre and laid in 50 × 50 cm tiles, so one square metre
   is four tiles. The stepper counts square metres because that is how a floor
   is measured and how it is priced; the tile count rides along underneath so
   nobody has to do the arithmetic to know what turns up on the truck.

   THE MINIMUM IS THE STEPPER, not a validation message. Tiles are not sold
   loose, so the smallest order is one full square metre — four of them — and
   stepping back down from one goes to none rather than to a part-metre. A
   customer cannot land on a quantity we would have to refuse.

   Pricing is the caller's job, as with IFZPlates — the rate could differ
   between a standalone order and one riding along with a machine.
   ========================================================================== */
window.IFZFloor = function (container, onChange, rate) {
  'use strict';

  /* The rate is passed in so the line below can say what the money buys. The
     stepper counts square metres, and a "1" sitting next to "$39" reads to
     some people as one tile for thirty-nine dollars — which is four times the
     real price and exactly the kind of misreading that gets discovered at the
     door. So the count of TILES leads. */
  var RATE = rate || 39;

  var MIN_M2 = 1;                /* one square metre — four tiles — at $39 */
  var MAX_M2 = 60;
  var TILES_PER_M2 = 4;          /* 50 × 50 cm */

  var m2 = 0;

  function tiles() { return m2 * TILES_PER_M2; }

  var row = document.createElement('div');
  row.className = 'plr';

  /* A photograph rather than the plates' text disc. "Rubber Gym Flooring" in
     a list under a machine is a phrase people read past — a picture of a
     speckled tile with its 15 mm edge is not, and it is the only thing in
     this section that needs explaining at all. Sized to match .addon__img,
     because the bench and the bar directly above it already show a picture
     and a different size would read as a different kind of thing. */
  var badge = document.createElement('span');
  badge.className = 'plr__pic';
  badge.appendChild(window.IFZPic('assets/floor-15mm-760.jpg', 'Rubber gym flooring tile'));

  var name = document.createElement('span');
  name.className = 'plr__name plr__name--wrap';
  name.innerHTML = '<b>Rubber Gym Flooring</b>' +
                   '<small>15 mm &middot; 50 &times; 50 cm tiles &middot; 4 to the m&sup2;</small>';

  var qty = document.createElement('div');
  qty.className = 'plr__qty';
  var minus = document.createElement('button');
  minus.type = 'button';
  minus.textContent = '\u2212';
  minus.setAttribute('aria-label', 'Less flooring');
  var n = document.createElement('span');
  n.textContent = '0';
  var plus = document.createElement('button');
  plus.type = 'button';
  plus.textContent = '+';
  plus.setAttribute('aria-label', 'More flooring');
  qty.appendChild(minus); qty.appendChild(n); qty.appendChild(plus);

  var side = document.createElement('span');
  side.className = 'plr__side';
  var added = document.createElement('b');
  added.textContent = '(0 tiles)';
  side.appendChild(document.createTextNode('m\u00b2 '));
  side.appendChild(added);

  var sum = document.createElement('p');
  sum.className = 'plr__sum';

  function refresh() {
    n.textContent = m2;
    added.textContent = '(' + tiles() + ' tiles)';
    sum.innerHTML = m2 === 0
      ? 'The smallest order is <b>4 tiles</b> — one square metre — for <b>$' + RATE + '</b>.'
      : '<b>' + tiles() + ' tiles</b> — ' + m2 + ' m² — <b>$' + (m2 * RATE) + '</b>';
    onChange(m2);
  }

  minus.addEventListener('click', function (e) {
    e.stopPropagation();
    /* straight back to nothing: part of a square metre is not an order */
    if (m2 <= MIN_M2) m2 = 0; else m2 -= 1;
    refresh();
  });
  plus.addEventListener('click', function (e) {
    e.stopPropagation();
    if (m2 === 0) m2 = MIN_M2;
    else if (m2 < MAX_M2) m2 += 1;
    refresh();
  });

  row.appendChild(badge); row.appendChild(name); row.appendChild(qty); row.appendChild(side);
  container.appendChild(row);
  container.appendChild(sum);
  refresh();

  return { m2: function () { return m2; }, tiles: tiles, MIN_M2: MIN_M2 };
};
